// src/js/components/product-modal.js
if (!customElements.get("product-modal")) {
  class ProductModal extends ModalDialog {
    /**
     * Construct
     */
    constructor() {
      super();
    }
    /**
     * Hide
     */
    hide() {
      super.hide();
    }
    /**
     * Show
     * 
     * @param {Element} opener 
     */
    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }
    /**
     * Show Active Media
     */
    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`
      ).forEach((element) => {
        element.classList.remove("active");
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector("template");
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add("active");
      setTimeout(() => {
        activeMedia.scrollIntoView();
      }, 200);
      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
      if (activeMedia.nodeName == "DEFERRED-MEDIA" && activeMediaContent && activeMediaContent.querySelector(".js-youtube"))
        activeMedia.loadContent();
    }
  }
  customElements.define("product-modal", ProductModal);
}
